import React from 'react'

const PartyDetailsContext = React.createContext()

export default PartyDetailsContext
